<script lang="ts">
    import PanelistsPage from '@Evaluation/Estimations/Pages/PanelistsPage'
    export default PanelistsPage
</script>

<template>
    <div>
        <PanelistAlternativesSelector v-if="panelistAlternativesSelector" v-bind="panelistAlternativesSelector"
                                      @confirm="handleUpdatePanelistAlternativesCommand"
                                      @close="closePanelistAlternativesSelector" />

        <PanelistsSelector v-if="panelistsSelector" v-bind="panelistsSelector"
                           @showPanelistAlternativesSelector="showPanelistAlternativesSelector"
                           @includePanelist="handleIncludePanelistCommand"
                           @excludePanelist="handleExcludePanelistCommand"
                           @close="closePanelistsSelector" />

        <EmailSender :viewModel="emailSender"
                     @form-submit="handleSendEmailCommand" />

        <SurveyAccessLinks :viewModel="surveyAccessLinks"
                           @send-email="handleSendEmailCommand"
                           @download-links="downloadLinks" />


        <PortfolioNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div v-if="Initialized" class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h6>
                        <a class="text-dark" v-sanitizedHref="`/#/pp/assessments/${workspaceId}/${projectId}`">
                            <i class="fa fa-angle-double-left" aria-hidden="true"></i> Back to panels
                        </a>
                    </h6>
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">
                        Panelists: {{SurveyName}} ({{Progress}}%)
                    </h1>
                    <p class="mb-0">Targeting: {{TargetingLabel}}</p>
                </div>
                <div class="col-lg-6 text-right mt-auto">
                    <button role="button" class="btn btn-outline-secondary" style="padding: 0.7em 2em;" @click="showAccessLinks">Access links</button>
                    <button role="button" class="btn btn-success" style="padding: 0.7em 2em;" @click="showPanelistsSelector" :disabled="!EnabledAddingPanelists">Add panelists</button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container">

            <h3 v-if="!Initialized"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>

            <div v-if="Initialized">
                <nav class="navbar navbar-light navbar-expand-md bg-light" role="navigation">
                    <form class="form-inline mr-2">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="NonePanelistsSelected" @click="SelectAllCommand"><i class="fa-regular fa-square"></i></button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="AnyPanelistsSelected && !AllPanelistsSelected" @click="UnselectAllCommand"><i class="fa fa-minus-square"></i></button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="AllPanelistsSelected" @click="UnselectAllCommand"><i class="fa-solid fa-square-check"></i></button>
                            <button type="button" class="btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"></button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click="SelectAllCommand">All</a>
                                <a class="dropdown-item" @click="UnselectAllCommand">None</a>
                                <a class="dropdown-item" @click="InverseSelectionCommand">Inverse</a>
                            </div>
                        </div>
                    </form>
                    <form class="form-inline mr-auto">
                        <button type="button" class="btn btn-sm" :class="[NonePanelistsSelected ? 'btn-outline-secondary' : 'btn-outline-primary']" :disabled="NonePanelistsSelected" @click="EmailManyCommand">
                            Send email ({{SelectedPanelistsCount}})
                        </button>
                    </form>
                    <form class="form-inline my-2 my-lg-0 mr-2">
                        <div class="dropdown">
                            Filter: <a class="text-primary font-weight-bold dropdown-toggle" data-toggle="dropdown">{{FilterLabel}}</a>
                            <div class="dropdown-menu dropdown-menu-right">
                                <a class="dropdown-item my-2" @click="resetFilters()">
                                    <span>All panelists</span>
                                </a>
                                <div class="dropdown-divider"></div>
                                <h6 class="dropdown-header">By progress:</h6>
                                <a class="dropdown-item my-2" @click="filterByProgress('Not started')">
                                    <span>Not started</span>
                                </a>
                                <a class="dropdown-item my-2" @click="filterByProgress('In progress')">
                                    <span>In progress</span>
                                </a>
                                <a class="dropdown-item my-2" @click="filterByProgress('Completed')">
                                    <span>Completed</span>
                                </a>
                                <h6 class="dropdown-header">By tag:</h6>
                                <a class="dropdown-item" v-for="t in tags" @click="filterByTag(t)">{{t}}</a>
                            </div>
                        </div>
                    </form>
                    <form class="form-inline my-2 my-lg-0" role="search">
                        <input class="form-control form-control-sm mr-sm-2" type="search" placeholder="Search" v-model="SearchPhrase">
                    </form>
                </nav>
                <br />
                <div class="row">
                    <div class="col">
                        <table class="table table-hover">
                            <tbody>
                                <tr v-for="p in PanelistsView" :key="p.ProjectUserId">
                                    <td style="width: 40px;" class="align-middle">
                                        <input type="checkbox" v-model="p.IsSelected" style="width: 20px; height: 20px;">
                                    </td>
                                    <td>
                                        <p class="fg-color-gray mb-0 mt-1">
                                            <span>{{p.Name}}</span>
                                        </p>
                                        <small class="text-muted" v-if="p.HasEmail">{{p.Email}}</small>
                                        <small class="text-danger" v-if="!p.HasEmail">Email not provided</small>
                                    </td>
                                    <td class="align-middle">
                                        <div class="progress" style="margin: 0;">
                                            <div :style="{ width: getProgressStr(p.Progress) }" v-bind:title="getProgressStr(p.Progress)" class="progress-bar progress-bar-success progress-bar-striped" role="progressbar"></div>
                                        </div>
                                    </td>
                                    <td class="align-middle" v-if="TargetingEnabled">
                                        <a @click="showPanelistAlternativesSelector(p.ProjectUserId)" class="text-primary">
                                            {{p.AlternativesCount}}
                                        </a>
                                    </td>
                                    <td class="align-middle" style="width: 120px;">
                                        <div class="dropdown">
                                            <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                                Actions
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a class="dropdown-item" v-sanitizedHref="`/#/est/dashboard/${workspaceId}/${surveyId}/${p.ProjectUserId}`" target="_blank">Review</a>
                                                <a class="dropdown-item" @click="EmailOneCommand(p.ProjectUserId)">Email</a>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" v-if="!TargetingEnabled" @click="handleExcludePanelistCommand(p.ProjectUserId)">Exclude</a>
                                                <a class="dropdown-item" v-if="TargetingEnabled" @click="showPanelistAlternativesSelector(p.ProjectUserId)">Targeting</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
